export default __webpack_public_path__ + "static/media/009.095f0be7.jpg";